// extracted by mini-css-extract-plugin
module.exports = {"splitWrap":"splitWrap--LmeIE","splitLeft":"splitLeft--kPKvq","splitRight":"splitRight--JmzaU"};